import React from "react";
import PropTypes from "prop-types";
import { Grid, Container } from "@mui/material";
import SpotlightSection from "./spotlight_section";
import "@fortawesome/fontawesome-free/css/all.css";
import styles from "./index.module.scss";
import useHomePageFiles from "../../utils/useHomePageFiles";

function Template({ data }) {
  const {
    title,
    text,
    memberSectionTitle,
    currentService: {
      name,
      overview,
      slug,
      class_name: className,
      company: { big_logo: serviceLogoUrl, url_segment: urlSegment }
    },
    currentCompany
  } = data;

  const buildSvcLink = (companyUrlSegment, svcClassName, svcSlug) => {
    let normalizedClassName;

    switch (svcClassName) {
      case "Appliance":
        normalizedClassName = "distros/appliance";
        break;
      case "Consultant":
        normalizedClassName = "consulting";
        break;
      case "Distribution":
        normalizedClassName = "distros/distribution";
        break;
      case "PublicCloudService":
        normalizedClassName = "public-clouds";
        break;
      case "PrivateCloudService":
        normalizedClassName = "hosted-private-clouds";
        break;
      case "RemoteCloudService":
        normalizedClassName = "remotely-managed-private-clouds";
        break;
      case "TrainingService":
        normalizedClassName = "training";
        break;
      default:
        return "#";
    }
    return `/marketplace/${normalizedClassName}/${companyUrlSegment}/${svcSlug}`;
  };

  const memberCompanyLogoUrlOverride = useHomePageFiles(currentCompany.image);

  const memberCompanyLogoUrl = currentCompany.memberCompany.big_logo;

  const serviceCtaURL = buildSvcLink(urlSegment, className, slug);

  return (
    <Container maxWidth="lg" className={styles.wrapper}>
      <Grid container className={styles.sectionSpotlight}>
        <Grid item sm={12} md={6} className={styles.companySpotlight}>
          <SpotlightSection
            title={title}
            paragraph1={text}
            paragraph2={overview}
            logoURL={serviceLogoUrl}
            logoAlt={name}
            ctaURL={serviceCtaURL}
          />
        </Grid>
        <Grid item sm={12} md={6} className={styles.memberSpotlight}>
          <SpotlightSection
            title={memberSectionTitle}
            paragraph1={currentCompany.paragraph1}
            paragraph2={currentCompany.paragraph2}
            logoURL={memberCompanyLogoUrlOverride || memberCompanyLogoUrl}
            logoAlt={currentCompany.memberCompany.name}
            ctaURL={currentCompany.link}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

Template.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    currentService: PropTypes.shape({
      name: PropTypes.string,
      overview: PropTypes.string,
      call_2_action_url: PropTypes.string,
      company: PropTypes.shape({
        big_logo: PropTypes.string
      })
    }),
    memberSectionTitle: PropTypes.string,
    currentCompany: PropTypes.shape({
      memberCompany: PropTypes.shape({
        name: PropTypes.string,
        big_logo: PropTypes.string
      }),
      paragraph1: PropTypes.string,
      paragraph2: PropTypes.string,
      link: PropTypes.string,
      image: PropTypes.string
    }).isRequired
  }).isRequired
};

export default Template;
